
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MaterialModule } from '../../material.module';

/**
 * 輸入對話框組件
 *
 * 一個簡單的輸入對話框，用於從用戶獲取單一輸入值。
 * 此對話框提供標題、輸入欄位和確認/取消按鈕，讓用戶可以方便地
 * 輸入文字、數字或其他類型的資料。
 *
 * 使用方式：
 * ```typescript
 * const dialogRef = this.dialog.open(InputDialogComponent, {
 *   width: '250px',
 *   data: {
 *     title: '請輸入名稱',
 *     label: '名稱',
 *     inputType: 'text',
 *     inputValue: ''
 *   }
 * });
 * ```
 */
@Component({
  selector: 'app-input-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MaterialModule
],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <h2 mat-dialog-title class="text-center font-bold">{{ data.title }}</h2>
    <mat-dialog-content>
      <mat-form-field class="w-full mt-2">
        <mat-label>{{ data.label }}</mat-label>
        <input matInput [type]="data.inputType" [(ngModel)]="inputValue">
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions class="flex justify-center gap-4 pb-4">
      <button mat-stroked-button color="primary" (click)="onConfirm()">確定</button>
      <button mat-stroked-button color="warn" (click)="onCancel()">取消</button>
    </mat-dialog-actions>
  `,
})
export class InputDialogComponent {
  dialogRef = inject<MatDialogRef<InputDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  /** 輸入欄位的值 */
  inputValue: string;
  //public data: any= inject(MAT_DIALOG_DATA);

  /**
   * 建構函數
   * @param dialogRef 對話框參考，用於關閉對話框
   * @param data 對話框數據，包含title、label、inputType和inputValue
   */
  constructor() {
    this.inputValue = this.data.inputValue;
  }

  /**
   * 取消按鈕點擊處理
   * 關閉對話框並不返回值
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * 確認按鈕點擊處理
   * 關閉對話框並返回輸入的值
   */
  onConfirm(): void {
    this.dialogRef.close(this.inputValue);
  }
}
